<template lang="pug">
.conteudoo(:class='isLoading ? "--loading" : ""')
    .linha.--nova
            title-component(:label='getTitulo', style="font-size: 20px;")
    .linha.--nova
        .container
            .coluna
                .linha
                    button(
                        class="button-custom--",
                        @click='regerar($event)'
                    ) Regerar

                    button(
                        class="button-custom--",
                        :style='"--button-background-color: red;"'
                        @click='cancelar($event)'
                    ) Cancelar

    .coluna--nova
        P SUCESSO:
        ul
            li(v-for="(item, index) in getCorpoResposta.SUCESSO" :key="index")
                | Processo: {{ index }} : {{ item }}

        P ERROS:
        ul
            li(v-for="(item, index) in getCorpoResposta.ERROS" :key="index" class="linha")
                | Processo: {{ index }} : {{ item }}

        P EMAILS ENVIADOS:
        ul
            li(v-for="(item, index) in getCorpoResposta.EMAILS" :key="index")
                | {{ index }} : {{ item }}

</template>

<script>

import {
    regerTermosPorCondicaoEEnviarEmailCompromissarioExterno
} from '@/services/processo.service';

export default {

    name: 'RegerarTermoCmponent',

    data() {
        return {
            loading: false,
            titulo: 'Deseja regerar os PDF\'s dos termos referentes aos Processos com a condição AGUARDANDO_ASSINATURA e enviar e-emails para os compromissarios externos?',
            corpoResposta: ''
        };
    },

    computed: {
        getTitulo()  {
            return this.titulo;
        },
        getCorpoResposta()  {
            return this.corpoResposta;
        },

        isLoading()  {
            return this.loading;
        },
    },

    methods: {
        async regerar() {
            try {
                this.loading = true;
                const response = await regerTermosPorCondicaoEEnviarEmailCompromissarioExterno();

                if (response.status === 200) {
                    this.tokenSolicitado = true;
                    this.corpoResposta = response.data;
                }

            } catch (error) {
                this.apresentaToast(error, 'error');
            } finally {
                this.loading = false;
            }
        },

        apresentaToast(message, type) {
            if(!message)
                return;

            this.$toast({
                showClose: true,
                message: message,
                type: type
            });
        },

        cancelar() {
            this.$emit('cancelar', true);
        },

    },

};


</script>


<style lang="scss">
.conteudoo {
    max-height: 75vh;
    overflow-y: auto;
}

.linha.--nova{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 20px;
}

.coluna--nova{
    display: flex;
    max-width: 100% !important;
    flex-direction: column;
    align-items: flex-start;
}

.container {
    display: flex;
}

.--loading {
    position: relative;
}

.--loading:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary-smoke);
    background-image: url('../../../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
}

.button-custom-- {
    display: flex !important;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: center;
    border: none;
    text-decoration: none;
    padding: 10px 5px 10px 5px;
    border-radius: 5px;
    height: 50px;
    width: 120px;
    font-size: 20px;
    display: inline-block;
    cursor: pointer;
    color: var(--primary-white);
    background-color: var(--button-background-color, var(--primary-green));
    border: 1px solid transparent;
}

</style>





